import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
const SvgPricelineP = ({ title, titleId, ...props }, ref)=>/*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 40 40",
        focusable: "false",
        role: "img",
        ref: ref,
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ jsx("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ jsx("path", {
                fill: "currentColor",
                d: "M20.8003962,11.4434168 C19.833319,11.4434168 18.8343881,11.8571851 18.076271,12.8909693 C17.3156055,13.8878327 16.9741343,15.4397821 16.9741343,17.1254105 C16.9741343,19.3979534 17.5615158,20.8111313 18.2482808,21.5673725 C18.8687901,22.221763 19.7657892,22.5998836 20.6271123,22.5998836 C23.2098072,22.5998836 24.3488942,19.8104486 24.3488942,16.9853659 C24.3488942,14.6122455 23.695257,12.0990804 21.5228372,11.5452675 C21.2807494,11.4790645 21.0399357,11.4421437 20.799122,11.4421437 L20.8003962,11.4434168 Z M16.5969869,9.85963904 C16.7677225,9.65339145 16.9410065,9.448417 17.1117421,9.27527087 C18.0087412,8.41208652 19.6281814,7.6953125 21.6285914,7.6953125 C26.0384124,7.6953125 29.453125,11.0321948 29.453125,17.0235599 C29.453125,20.7054613 27.8311365,26.4269221 21.6604451,26.4269221 C19.6638575,26.4269221 18.6279764,25.7725316 17.2136738,24.9106204 L17.2136738,32.3138903 L11.875,32.3138903 L11.875,8.17273747 L16.5969869,8.17273747 L16.5969869,9.85963904 L16.5969869,9.85963904 Z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ forwardRef(SvgPricelineP);
const Memo = /*#__PURE__*/ memo(ForwardRef);
const PricelineP = Memo;
export { PricelineP as default };
